import * as React from "react"

import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"
import { ReadOnly, FieldItems } from "@tenforce/toolbox-field-react"
import { RowContent, Cell, CellType } from "@tenforce/toolbox-table-react"
import { Selector, ItemBlockPart } from "@tenforce/toolbox-selector-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { conceptUrl } from "../../../../util/UrlGenerator"
import env from "../../../../env"
import { Concept } from "../../../../models"

const applicationPath = env.applicationPath

interface Props {
    concept: Concept
}

export const ConceptRow = ({
    concept: {
        conceptId,
        conceptCode,
        conceptLabel,
        workspaceLabel,
        workspaceCode,
        isTemplate,
        isActive,
    },
}: Props): JSX.Element => (
    <RowContent
        key={conceptId}
        data-ft-concept-row
        data-ft-concept-title={conceptLabel.toLowerCase()}
    >
        <Cell type={CellType.action}>
            <ActionAnchor
                href={conceptUrl(applicationPath, conceptId)}
                actionType={ActionType.block}
                title={conceptLabel}
                extraClasses="tw-pl-6 text-black"
                data-ft-component="conceptLink"
                data-ft-concept-title={conceptLabel.toLowerCase()}
            >
                <div className="tw-truncate">{conceptLabel}</div>
            </ActionAnchor>
        </Cell>
        <Cell
            data-ft-component="concept-code"
            data-ft-concept-code={conceptCode}
        >
            <FieldItems>
                <ReadOnly value={`${conceptCode}`} title={`${conceptCode}`} />
            </FieldItems>
        </Cell>
        <Cell
            data-ft-component="workspace"
            data-ft-workspace-title={workspaceLabel.toLowerCase()}
        >
            <FieldItems>
                <ReadOnly value={workspaceLabel} title={workspaceLabel} />
            </FieldItems>
        </Cell>
        <Cell
            data-ft-component="workspace-code"
            data-ft-workspace-code={workspaceCode}
        >
            <FieldItems>
                <ReadOnly
                    value={`${workspaceCode}`}
                    title={`${workspaceCode}`}
                />
            </FieldItems>
        </Cell>
        <Cell data-ft-component="is-instance" data-ft-is-instance={!isTemplate}>
            <FieldItems>
                <ReadOnly
                    value={`${isTemplate ? "" : "instance"}`}
                    title={`${isTemplate ? "" : "instance"}`}
                />
            </FieldItems>
        </Cell>
        <Cell data-ft-component="is-active" data-ft-is-active={isActive}>
            <Selector isExpanded={true} isReadOnly={true}>
                <ItemBlockPart isSelected={true}>
                    {isActive ? Symbols.Confirm : Symbols.Cancel}
                </ItemBlockPart>
            </Selector>
        </Cell>
    </RowContent>
)

export default ConceptRow
